import {mapEntries} from '@yandex-delivery/utils'

import type {PickupPoint} from '../../../../api/address/model/types'
import type {FilterFunction, PaymentMethod as NddClaimPaymentMethod} from './types'

const isPostPayment = (payment: NddClaimPaymentMethod): boolean =>
  ['cash_on_receipt', 'card_on_receipt'].includes(payment)

export enum Filter {
  POST_PAYMENT = 'post_payment',
  POINT_TYPE = 'point_type',
}

export const filterFunctions: Record<Filter, FilterFunction> = {
  [Filter.POST_PAYMENT]: (value: PickupPoint) => value.paymentMethods.some(isPostPayment),
  [Filter.POINT_TYPE]: (value: PickupPoint, type?: PickupPoint['_type'] | boolean) => value._type === type,
}

export const INITIAL_VAlUES: Record<Filter, boolean> = mapEntries((_, value) => [value, false], Filter)
